"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, forwardRef } from "react";
import Select from "react-select";
import ErrorsInput from "@/components/global/inputs/errors-input";
import { FormError } from "@/TS/Interfaces/global_interfaces";
interface Select2OptionProps {
  placeholder?: string;
  options: any[];
  isClearable?: boolean;
  label?: string;
  onChange: (selectedOption: any) => void;
  error?: FormError;
  errorClassName?: string;
  versionKey?: string | number;
  value?: any;
  [key: string]: any;
}
const Select2Option = forwardRef<any, Select2OptionProps>(function Select2Option(t0, ref) {
  const $ = _c(39);
  let error;
  let errorClassName;
  let label;
  let onChange;
  let options;
  let placeholder;
  let rest;
  let t1;
  let value;
  let versionKey;
  if ($[0] !== t0) {
    ({
      placeholder,
      options,
      isClearable: t1,
      label,
      onChange,
      error,
      errorClassName,
      versionKey,
      value,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = error;
    $[2] = errorClassName;
    $[3] = label;
    $[4] = onChange;
    $[5] = options;
    $[6] = placeholder;
    $[7] = rest;
    $[8] = t1;
    $[9] = value;
    $[10] = versionKey;
  } else {
    error = $[1];
    errorClassName = $[2];
    label = $[3];
    onChange = $[4];
    options = $[5];
    placeholder = $[6];
    rest = $[7];
    t1 = $[8];
    value = $[9];
    versionKey = $[10];
  }
  const isClearable = t1 === undefined ? true : t1;
  const [isSearchable] = useState(true);
  const [isDisabled] = useState(false);
  const [isLoading] = useState(false);
  const [isRtl] = useState(false);
  const [changed, setChanged] = useState(false);
  let t2;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      control: _temp,
      option: _temp2,
      singleValue: _temp3,
      placeholder: _temp4
    };
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const customStyles = t2;
  const DropdownIndicator = _temp5;
  let t3;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      IndicatorSeparator: _temp6,
      DropdownIndicator
    };
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const customComponents = t3;
  let t4;
  if ($[13] !== label) {
    t4 = <label className="text-md">{label}</label>;
    $[13] = label;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== onChange) {
    t5 = selectedOption => {
      onChange(selectedOption);
      setChanged(true);
    };
    $[15] = onChange;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      ...customStyles,
      control: _temp7
    };
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== isClearable || $[19] !== isDisabled || $[20] !== isLoading || $[21] !== isRtl || $[22] !== isSearchable || $[23] !== options || $[24] !== placeholder || $[25] !== ref || $[26] !== rest || $[27] !== t5 || $[28] !== value || $[29] !== versionKey) {
    t7 = <Select ref={ref} key={versionKey} className="basic-single h-12" classNamePrefix={placeholder} onChange={t5} value={value} defaultValue={placeholder} placeholder={placeholder} isDisabled={isDisabled} isLoading={isLoading} isClearable={isClearable} isRtl={isRtl} isSearchable={isSearchable} name="color" options={options} styles={t6} components={customComponents} {...rest} />;
    $[18] = isClearable;
    $[19] = isDisabled;
    $[20] = isLoading;
    $[21] = isRtl;
    $[22] = isSearchable;
    $[23] = options;
    $[24] = placeholder;
    $[25] = ref;
    $[26] = rest;
    $[27] = t5;
    $[28] = value;
    $[29] = versionKey;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== changed || $[32] !== error || $[33] !== errorClassName) {
    t8 = <ErrorsInput changed={changed} error={error} className={errorClassName} />;
    $[31] = changed;
    $[32] = error;
    $[33] = errorClassName;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  let t9;
  if ($[35] !== t4 || $[36] !== t7 || $[37] !== t8) {
    t9 = <>{t4}{t7}{t8}</>;
    $[35] = t4;
    $[36] = t7;
    $[37] = t8;
    $[38] = t9;
  } else {
    t9 = $[38];
  }
  return t9;
});
export default Select2Option;
function _temp(provided, state) {
  return {
    ...provided,
    borderRadius: "0.375rem",
    border: state.isFocused ? "2px solid #9ca3af" : "2px solid transparent",
    boxShadow: state.isFocused ? "0 0 5px rgba(255, 102, 0, 0.5)" : "none",
    "&:hover": {
      border: "2px solid #9ca3af"
    }
  };
}
function _temp2(provided_0, state_0) {
  return {
    ...provided_0,
    color: "black",
    backgroundColor: state_0.isFocused ? "#f0f0f0" : "white",
    padding: 10
  };
}
function _temp3(provided_1) {
  return {
    ...provided_1,
    color: "black"
  };
}
function _temp4(provided_2) {
  return {
    ...provided_2,
    color: "#9B9B9B",
    fontStyle: "italic"
  };
}
function _temp5(_props) {
  return <div className="px-2"><svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" fill="black"><path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" /></svg></div>;
}
function _temp6() {
  return null;
}
function _temp7(provided_3, _state) {
  return {
    ...provided_3,
    height: "48px",
    borderRadius: "0.5rem"
  };
}